export default __webpack_public_path__ + "static/media/intro.85d4829f.mp4";